import React from 'react';
import { Box } from '@material-ui/core';

const LogoText = (props) => <Box style={{marginLeft:"-4px", zIndex:"1", borderRadius: "3px"}} className="header-logo-text p-0 bg-white">
    <span className="header-logo-text pl-0 pr-1">
        <span style={{color: "#E62E2D"}}>eebac</span>
        <span style={{color: "#11253F"}}>.com</span>
    </span>
</Box>


export default LogoText;